<template>
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardContainerAstrologyDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-astrology">Metrics Dashboard</h4>
              </div>
            </div>
          </div>


        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DashboardCard from "@/components/dashboard/Card";
// import DashboardTable from "@/components/dashboard/Table";
// import DashboardStatistics from "@/components/dashboard/StatisticsChart";
// import DashboardStatisticsData from "@/components/dashboard/StatisticsData";
// import DashboardRevenueChart from "@/components/dashboard/RevenueChart";
// import DashboardRevenueData from "@/components/dashboard/RevenueData";

export default {
  name: "AstrologyDashboard",
  components: {
    // DashboardCard,
    // DashboardTable,
    // DashboardStatistics,
    // DashboardStatisticsData,
    // DashboardRevenueChart,
    // DashboardRevenueData,
  },
  data() {
    return {
    };
  },
  methods: {},
  mounted(){
    //   console.log(window.localStorage.getItem("user"))
  }
};
</script>



// WEBPACK FOOTER //
// src/components/astrology_ventures/admin/Dashboard.vue